import { MemberProfile } from 'types'
import { UserProfileCard } from './UserProfileCard'
import { useAuth } from 'hooks/UseAuth'
import { RippleAnimation } from './RippleAnimation'
import { SkeletonProfileCard } from './SkeletonProfileCard'
import { ErrorProfileCard } from './ErrorProfileCard'

interface Props {
  profile?: MemberProfile
  error: boolean
  reduced: boolean
}

export const UserProfileCardContainer = ({ reduced, profile, error }: Props) => {
  const auth = useAuth()

  if (profile) {
    return <UserProfileCard reduced={reduced} profile={profile} isMe={auth?.id === profile.id} />
  }

  if (error) {
    return <ErrorProfileCard />
  }

  return (
    <RippleAnimation>
      <SkeletonProfileCard />
    </RippleAnimation>
  )
}
